<template>
  <div class="d-flex justify-content-center align-items-center" style="min-height: 550px">
    <div>
      <div class="no-content-container">
        <div class="row">
          <div class="col-lg-12 p-0">
            <div class="card-register card-item-register2">
              <div class="d-flex justify-content-center cntainer align-items-center card-body flex-column">
                <img
                  :width="150"
                  :height="150"
                  :src="require('@/assets/' + image + '')"
                  class=" rounded-custom lazy pt-3"
                />
                <p class="black-text fs-20 py-3">{{title}}</p>
                <p class="fs-15 pt-2 mx-4 center-p">{{disc}}</p>
                <nuxt-link :to="link"><button @click="$emit('itemClicked')" type="button" class="my-5 btn theme-btn theme-btn-full-radius">{{linkTitle}}</button></nuxt-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoContent",
  props: {
    title: "",
    disc: "",
    linkTitle: "",
    link: "",
    image: {
        type: String,
        default: ""
    }
  },
};
</script>

<style></style>
